import {Injectable} from '@angular/core';
import * as signalR from '@microsoft/signalr';
import {HttpTransportType} from '@microsoft/signalr';

import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {Subscriber} from 'rxjs/Subscriber';
import {urls} from '../../../../environments/environment';


@Injectable()
export class ClientNotificationService {

  constructor( private http: HttpClient) {
  }

  public openConnection(eventNames: string[], contaId: string): Observable<any> {
    return new Observable((obs) => {
      const connection = new signalR.HubConnectionBuilder()
        .withUrl(`${urls.clientNotification}/NotificationHub/?ContaId=${contaId}`,
          {skipNegotiation: true, transport: HttpTransportType.WebSockets })
        .withAutomaticReconnect([5000, 5000, 5000, 10000])
        .build();
      const subsc = new Observable((observer: Subscriber<{eventName: string, eventData: string | object}>) => {

        for (const eventName of eventNames) {
          connection.on(eventName, data => {
            const eventData: any = {};
            if (eventName === 'onCentralNotification') {
              for (const [key, value] of Object.entries(data)) {
                eventData[this.turnPascalCase(key)] = value;
              }
            }

            if (eventName === 'onGympassCheckinNotification') {
              for (const [key, value] of Object.entries(data)) {
                eventData[this.turnPascalCase(key)] = value;
              }
              eventData['Person'] = {};
              for (const [key, value] of Object.entries(data.person)) {
                eventData['Person'][this.turnPascalCase(key)] = value;
              }
            }

            if (eventName === 'onPixNotification') {
              eventData['Pix'] = { ...data};
            }
            observer.next({
              eventName,
              eventData
            });
          });
        }
        connection.start().then(() => {
          observer.next({
            eventName: 'onConnected',
            eventData: 'ok'
          });
        });
        connection.onclose(e => {
          observer.next({
            eventName: 'onConnectionClose',
            eventData: e
          });
        });
        connection.onreconnecting(e => {
          observer.next({
            eventName: 'onConnectionReconnecting',
            eventData: e
          });
        });
        connection.onreconnected(e => {
          observer.next({
            eventName: 'onConnectionReconnected',
            eventData: e
          });
        });
      }).subscribe((res) => {
        obs.next(res);
      }, error => {
        obs.next(error);
        obs.complete();
      });
      return function unsubscribe() {
        connection.stop().then();
      };
    });

  }

  private turnPascalCase(key: string): string {
    return `${key[0].toUpperCase()}${key.substring(1, key.length)}`;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/client-notification/client-notification.service.ts